export class VehicleEmailModel{
    to:string;
    requestNo: string;
    subject:string;
    html: string
}
